import { j as jsxRuntimeExports } from "./auth-service-tools177.js";
import "react";
import { getRadius } from "./auth-service-tools185.js";
import { createVarsResolver } from "./auth-service-tools191.js";
import { useProps } from "./auth-service-tools225.js";
import { useStyles } from "./auth-service-tools198.js";
import { factory } from "./auth-service-tools248.js";
import { UnstyledButton } from "./auth-service-tools258.js";
import { useCheckboxGroupContext } from "./auth-service-tools317.js";
import { CheckboxCardProvider } from "./auth-service-tools324.js";
import classes from "./auth-service-tools326.js";
const defaultProps = {
  withBorder: true
};
const varsResolver = createVarsResolver((_, _ref) => {
  let {
    radius
  } = _ref;
  return {
    card: {
      "--card-radius": getRadius(radius)
    }
  };
});
const CheckboxCard = factory((_props, ref) => {
  const props = useProps("CheckboxCard", defaultProps, _props);
  const {
    classNames,
    className,
    style,
    styles,
    unstyled,
    vars,
    checked,
    mod,
    withBorder,
    value,
    onClick,
    ...others
  } = props;
  const getStyles = useStyles({
    name: "CheckboxCard",
    classes,
    props,
    className,
    style,
    classNames,
    styles,
    unstyled,
    vars,
    varsResolver,
    rootSelector: "card"
  });
  const ctx = useCheckboxGroupContext();

  const _checked = typeof checked === "boolean" ? checked : (ctx == null ? void 0 : ctx.value.includes(value || "")) || false;

  return /* @__PURE__ */jsxRuntimeExports.jsx(CheckboxCardProvider, {
    value: {
      checked: _checked
    },
    children: /* @__PURE__ */jsxRuntimeExports.jsx(UnstyledButton, {
      ref,
      mod: [{
        "with-border": withBorder,
        checked: _checked
      }, mod],
      ...getStyles("card"),
      ...others,
      role: "checkbox",
      "aria-checked": _checked,
      onClick: event => {
        onClick == null ? void 0 : onClick(event);
        ctx == null ? void 0 : ctx.onChange(value || "");
      }
    })
  });
});
CheckboxCard.displayName = "@mantine/core/CheckboxCard";
CheckboxCard.classes = classes;
export { CheckboxCard };